"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoordinateConverter = exports.AltiumCoordinateSchema = void 0;
const zod_1 = require("zod");
exports.AltiumCoordinateSchema = zod_1.z
    .object({
    x: zod_1.z.number(),
    y: zod_1.z.number(),
})
    .strict();
class CoordinateConverter {
    static convertCoordinate(x, xFrac = 0, y, yFrac = 0, invertY = true) {
        const finalX = x + xFrac / 100000;
        let finalY = y + yFrac / 100000;
        if (invertY) {
            finalY = -finalY;
        }
        return { x: finalX * 10, y: finalY * 10 };
    }
    static convertCoordinateNumber(value, valueFrac = 0, valueFrac1 = 0) {
        return (value + valueFrac / 100000 + valueFrac1 / 1000000) * 10;
    }
    static parseFractionalValue(properties, key) {
        return (parseInt(properties[key]?.value ?? '0', 10) +
            parseInt(properties[`${key}_frac`]?.value ?? '0', 10) / 100000 +
            parseInt(properties[`${key}_frac1`]?.value ?? '0', 10) / 1000000);
    }
    static parseFractionalCoordinate(properties, key) {
        return CoordinateConverter.parseFractionalValue(properties, key) * 10;
    }
    static parseFractionalPoint(properties, xKey, yKey, invertY = true) {
        const x = CoordinateConverter.parseFractionalValue(properties, xKey);
        const y = CoordinateConverter.parseFractionalValue(properties, yKey);
        return { x: x * 10, y: (invertY ? -y : y) * 10 };
    }
    static convertObjectLocation(properties) {
        return CoordinateConverter.parseFractionalPoint(properties, 'location.x', 'location.y');
    }
    static convertColor(altiumColor) {
        const r = altiumColor & 0xff;
        const g = (altiumColor >> 8) & 0xff;
        const b = (altiumColor >> 16) & 0xff;
        return { r, g, b };
    }
    static rgbToAltiumColor(r, g, b) {
        return (b << 16) | (g << 8) | r;
    }
    static milsToMm(mils) {
        return mils * 0.0254;
    }
    static mmToMils(mm) {
        return mm / 0.0254;
    }
    static altiumBool(value) {
        return value === 'T' || value === 'TRUE' || value === '1' || value === 'ON' || value === 'YES';
    }
    static convertJustification(justification) {
        const horizontal = justification % 3;
        const vertical = Math.floor(justification / 3);
        return [horizontal - 1, 1 - vertical];
    }
}
exports.CoordinateConverter = CoordinateConverter;
//# sourceMappingURL=CoordinateConverter.js.map